import React, { useState, useRef, useEffect, useCallback } from 'react'
import { ImLinkedin2 } from 'react-icons/im';
import { AiOutlineTwitter } from 'react-icons/ai';
import { FaWhatsapp } from 'react-icons/fa';
import { MdMailOutline } from 'react-icons/md';
import { AiOutlinePlus } from 'react-icons/ai';
import useIsInViewport from 'use-is-in-viewport'

import Heading2 from '../../../elements/titles/Heading2'
import Heading3 from '../../../elements/titles/Heading3'
import Container from '../../../utils/Container'
import LoaderCircle from '../../../utils/LoaderCircle'
import Loader from '../../../utils/Loader'
import Paragraph from '../../../elements/p/Paragraph'
import Button from '../../../elements/buttons/Button'
import BigInput2 from '../../../elements/inputs/BigInput2'
import bgTraductionTypes from '../../../../medias/images/bg-traductionTypes.svg'

import { createContact } from "../../../../api/contacts/index"
import { uploadFile } from "../../../../api/utils/index"

const ContactTypes = () => { 

	const [isInViewport, targetRef] = useIsInViewport()
	const fileRef = useRef()

	// initial form data
	const initialDatas = { 
		firstName: "",
		lastName: "",
		email: "",
		subject: "",
		message: "",
		file: null
	}

	// state variables
	const [contactDatas, setContactDatas] = useState(initialDatas)
	const [loading, setLoading] = useState(false)
	const [progress, setProgress] = useState(0)
	const [documentUrl, setDocumentUrl] = useState("")
	const [dowloadError, setDowloadError] = useState("")

	console.log(progress)


	useEffect(() => {
		const sendContact = async () => {
			if(documentUrl){
				try{
					const result = await createContact({...contactDatas, file: documentUrl})
					console.log(result)
					setDocumentUrl("")
					setContactDatas(initialDatas)
				}catch(err){
					console.log(err)
				}finally{
					setLoading(false)
				}
			}
		}

		sendContact()
	}, [documentUrl])


	const memoizedCreateContact = useCallback(
	  () => {
	    createContact({...contactDatas, file: documentUrl})
	    .then(result => {
	    	console.log(result)
	    	setLoading(false)
	    })
	  },
	  [documentUrl],
	);

	// handlers
	const handleChange = (event) => {

		if(event.target.id === "file")
			return setContactDatas(prevContactData => ({ ...prevContactData, [event.target.id] : event.target.files[0] }))

		const target = event.target.id ? event.target.id : "message"
		setContactDatas(prevContactData => ({ ...prevContactData, [target] : event.target.value }))
	}

	const handleSubmit = async (event) => {
		event.preventDefault()

		console.log("soumission....")

		setLoading(true)

		if(!contactDatas.file){
			try{
				const result = await createContact(contactDatas)
				console.log(result) 
			}catch(err){
				console.log(err)
			}finally{
				setLoading(false)
				return;
			}
		}

		try{
			const result = await uploadFile(contactDatas.file, setDocumentUrl, setProgress, setLoading)
			console.log(result)
		}catch(err){
			console.log(err)
		}
	}


	const {
		firstName,
		lastName,
		email,
		subject,
		message,
		file
	} = contactDatas

	return (
		<Container
			ref={targetRef}
			className={`${ isInViewport ? "visibleDiv" : "hiddenDiv"} p-3 mt-10 flex justify-center`} 
		>

			<div className="max-w-4xl mx-auto mt-12 md:mt-24">
				<form 
					action="" className="h-96 flex flex-col space-y-3 w-full"
					onSubmit={ event => handleSubmit(event) }
				>
					<div className="md:flex md:space-x-2 space-y-3 md:space-y-0" >
						<BigInput2
							type="text"
							placeholder="Votre nom"
							classe="mt-8"
							value={firstName}
							handleChange={ (event) => handleChange(event) }
							id="firstName"
							required={true}
						/>
						<BigInput2
							type="text"
							placeholder="Votre prenom"
							classe="mt-8"
							handleChange={ (event) => handleChange(event) }
							id="lastName"
							required={true}
						/>
					</div>
					<div className="md:flex md:space-x-2 space-y-3 md:space-y-0">
						<BigInput2
							type="email"
							placeholder="Votre email "
							classe="mt-8"
							handleChange={ (event) => handleChange(event) }
							id="email"
							required={true}
						/>

						<BigInput2
							type="text"
							placeholder="Sujet"
							classe="mt-8"
							handleChange={ (event) => handleChange(event) }
							id="subject"
							required={true}
						/>
					</div>
					<textarea placeholder="Votre message..." name="" id="message" 
						className="bg-custom-gray rounded-2xl w-full h-60 text-sm font-nunito focus:outline-none px-3 py-2 md:py-3 text-gray-500"
						required={true}
						onChange={ (event) => handleChange(event)  }
					>
					</textarea>

					<div className="flex justify-between items-center">
						<div>
							<button onClick={ (event) => { event.preventDefault(); fileRef.current.click() } }
								className="bg-custom-gray text-sm text-gray-500 rounded-full font-nunito py-2 px-3"
							>
								Entrer un fichier
							</button>
							<input 
								ref={fileRef} 
								type="file" 
								id="file" 
								name="file"
								onChange={ event => handleChange(event) }
								hidden 
							/>
						</div>
						<div className={`${ loading && "opacity-40" } relative`}>
							<button 
								className={`${loading && "opacity-40"} p-2 text-white bg-primary rounded hover:opacity-80 cursor-pointer font-primary letter-spacing-loose`}
							>
								Envoyer
							</button>
							{ loading && <LoaderCircle size="small" color="#455A64" /> }
						</div>
					</div>
				</form>
				<div className="w-full sm:w-80 flex justify-between mt-20 md:mt-28">
					<SmallSocial
						icone={ <ImLinkedin2 size="22" color="#FFF" /> }
						bgIconDiv="#0e76A8"
						link="https://www.linkedin.com/in/ritansangou/"
					/>

					<SmallSocial
						icone={ <FaWhatsapp size="22" color="#FFF" /> }
						bgIconDiv="#075e54"
						link="https://wa.me/23791000782"
					/>

					<SmallSocial
						icone={ <MdMailOutline size="22" color="#FFF" /> }
						bgIconDiv="#db4a39"
						link="mailto:rita.nsangou@yahoo.com"
					/>

					<SmallSocial
						icone={ <AiOutlineTwitter size="22" color="#FFF" /> }
						bgIconDiv="#00acee"
						link="https://twitter.com/rita_nsangou"
					/>
				</div>
			</div>

		</Container>
	)
}

const Social = (props) => {

	const { text, icone, bgIconDiv, positionIcon, order, link } = props

	return(
		<a href={ link } target="_blanck" className={`group rounded-lg shadow-lg cursor-pointer ${ order }`}>
			<div className={``}>
				<div className="group-hover:bg-gray-100 p-6 md:p-10">
					<div className={`flex ${positionIcon}`}>
						<div className="group-hover:scale-75 transition duration-400 ease-out hover:ease-in w-16 h-16 md:w-20 md:h-20 rounded-full flex justify-center items-center" 
							 style={{ backgroundColor: `${bgIconDiv}` }}
						>
							{ icone }
						</div>
					</div>
					<Paragraph classe="mt-5">
						{ text }
					</Paragraph>
				</div>
			</div>
		</a>
	)
}

const SmallSocial = (props) => {

	const { icone, bgIconDiv, order, link } = props

	return(
		<a href={ link } target="_blanck" className="flex justify-center items-center rounded-full shadow-sm cursor-pointer w-8 h-8 md:w-10 md:h-10">
			<div className="hover:scale-75 transition duration-400 ease-out hover:ease-in  rounded-full flex justify-center items-center w-full h-full" 
				 style={{ backgroundColor: `${bgIconDiv}` }}
			>
				{ icone }
			</div>
		</a>
	)
}


export default ContactTypes